import React from 'react';
import Header from '../../Utils/Header'
import Footer from '../../Utils/Footer'
import registrar from '../../images/registrar.png'
import { Link } from "react-router-dom";

const Registrar = () => {
    return ( 

        <>
        <Header/>
            <div className="container-fluid bg-light pt-4">
                <div className="row">
                    <div className="col-6 mt-5 d-flex">
                        <img src={registrar} alt="Registrar" className="img-fluid mx-auto mt-5" />
                    </div>
                    <div className="col-6 mt-5 ">
                        <h2 className="lead mt-5">CREAR UNA CUENTA NUEVA</h2>
                        <form className="d-block">

                            <div className="form-group">
                                <label htmlFor="nombre">Nombre</label>
                                <input type="text" className="form-control col-5" id="nombre" name="nombre"/>
                            </div>

                            <div className="form-group">
                                <label htmlFor="nombre_usuario">Nombre de Usuario</label>
                                <input type="text" className="form-control col-5" id="nombre_usuario" name="nombre_usuario"/>
                            </div>

                            <div className="form-group">
                                <label htmlFor="email">E-mail</label>
                                <input type="email" className="form-control col-5" id="email" name="email"/>
                            </div>

                            <div className="form-group">
                                <label htmlFor="confirmar_email">Confirmar E-mail</label>
                                <input type="email" className="form-control col-5" id="confirmar_email" name="confirmar_email"/>
                            </div>

                            <p className="lead textos-small">Con tu mismo E-mail y Nombre de usuario también podrás acceder a los portales. </p>
                            <button type="submit" className="btn btn-primary mb-2 btn-send">Registrar</button>
                        </form>
                        <Link to='/recuperar'>
                            <p className="lead">¿Olvidaste tu contraseña?</p>
                        </Link>
                    </div>
                </div>
            </div>
        <Footer/>
        </>

     );
}
 
export default Registrar;